import { Checkbox } from '@/components/ui/checkbox';
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
  FormField,
} from '@/components/ui/form';
import { cn } from '@/lib/utils';
import React from 'react';
import { FieldPathByValue, FieldValues } from 'react-hook-form';

import { FieldOptions, FieldProps } from './shared';

export function CheckboxFieldMultiple<
  T extends FieldValues,
  P extends FieldPathByValue<T, string[]>,
>({
  control,
  name,
  rules,
  label,
  description,
  className,
  options,
  ...props
}: FieldProps<T, P> &
  React.ComponentPropsWithoutRef<typeof Checkbox> &
  FieldOptions) {
  return (
    <FormField
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value, onChange, ...field } }) => (
        <FormItem className="grow">
          <div className="mb-4">
            <FormLabel>{label}</FormLabel>
            <FormDescription>{description?.(value)}</FormDescription>
          </div>
          <FormControl>
            <div role="group" aria-label={label}>
              {options.map((option) => (
                <FormItem
                  key={option.id}
                  className={cn(
                    'flex flex-row items-start py-1 space-x-3 space-y-0',
                    className
                  )}
                >
                  <FormControl>
                    <Checkbox
                      checked={(value as string[]).includes(option.id)}
                      onCheckedChange={(checked) => {
                        return checked
                          ? onChange([...value, option.id])
                          : onChange(
                              (value as string[]).filter(
                                (value) => value !== option.id
                              )
                            );
                      }}
                      {...props}
                      {...field}
                    />
                  </FormControl>
                  <FormLabel className="font-normal">{option.label}</FormLabel>
                </FormItem>
              ))}
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
